import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

export const FilteredViewToggler = () => {
  return (
    <Card>
      <CardContent sx={{ px: 2, py: 1, display: 'flex', justifyContent: 'space-between', '&:last-child': { pb: 1 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
          <Box>
            <Skeleton variant="rounded" width={22} height={10} />
          </Box>
          <Box>
            <Skeleton variant="rectangular" width={330} height={20} sx={{ mb: 0.25 }} />
            <Skeleton variant="rectangular" width={300} height={20} />
          </Box>
        </Box>
        <Stack spacing={1} direction="row">
          <Skeleton variant="rounded" width={160} height={44} />
          <Skeleton variant="rounded" width={172} height={44} />
        </Stack>
      </CardContent>
    </Card>
  );
};
